<div class="background-spinner" *ngIf="loading">
    <mat-progress-spinner class="loader-spinner" [color]="color" [mode]="mode" [value]="value"></mat-progress-spinner>
</div>